import { render, staticRenderFns } from "./selectStaff.vue?vue&type=template&id=151e7a4e"
import script from "./selectStaff.vue?vue&type=script&lang=js"
export * from "./selectStaff.vue?vue&type=script&lang=js"
import style0 from "./selectStaff.vue?vue&type=style&index=0&id=151e7a4e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports